import { useState } from 'react';

// Imports MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Imports static data
import SampleData from './../../../constants/storedata.json';
//import StoreData from './../../../constants/storedata.json';
import {
    data_waste,
    /*data_stockout,*/
    data_heatmap,
    data_preplist,
    data_shelflife_default,
    data_shelflife_options,
    data_leadtime_default,
    data_leadtime_options,
    data_prioritization_default,
} from './../../../constants/data';

// Imports custom components
import {
    StoreSelect,
    LeadSelect,
    ShelfSelect,
    IngredientSlider,
    BarChart,
    HeatMap,
    PrepList,
} from '.';

import logo from './logo.png';
import logo_bartaco from './logo_bartaco.png';

export function Demo() {
    const [sliders, setSliders] = useState(data_prioritization_default);
    const [shelfLifes, setShelfLifes] = useState(data_shelflife_default);
    const [leadTimes, setLeadTimes] = useState(data_leadtime_default);

    const setArrayState = (index: number, val: any, func: any, state: any) => {
        let tempArray = state;
        tempArray[index] = val;
        func([...tempArray]);
    };

    return (
        <Box
            width="100%"
            sx={{
                display: 'flex',
                flexDirection: 'row',
            }}
        >
            <Box
                width="100%"
                height="100vh"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: 2,
                    backgroundColor: '#F3F3F3',
                }}
            >
                <Box
                    width="100%"
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        boxShadow: 4,
                        backgroundColor: '#DDDDDD',
                    }}
                >
                    <Box
                        sx={{
                            width: '450px',
                            margin: 2,
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        {window.location.pathname === '/bartaco' && (
                            <Box
                                sx={{
                                    height: '55px',
                                    width: '55px',
                                    marginRight: 2,
                                    backgroundImage: `url(${logo_bartaco})`,
                                    backgroundSize: '55px',
                                }}
                            />
                        )}
                        <Box width="300px">
                            <StoreSelect />
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            height: '55px',
                            width: '300px',
                            margin: 2,
                            backgroundImage: `url(${logo})`,
                            backgroundSize: '300px',
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-around',
                        margin: '0 20px',
                        gap: 5,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                        }}
                    >
                        <Typography>Items</Typography>
                        <Box
                            height="stretch"
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 5,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                    alignItems: 'center',
                                    margin: '-5px 0 5px 0',
                                }}
                            >
                                {SampleData.s7002.map((item, index) => (
                                    <Typography key={index}>
                                        {item.item}
                                    </Typography>
                                ))}
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                    alignItems: 'center',
                                    alignContent: 'stretch',
                                }}
                            >
                                {SampleData.s7002.map((_, index) => (
                                    <LeadSelect
                                        key={index}
                                        index={index}
                                        label={index === 0}
                                        leadTimes={leadTimes}
                                        options={data_leadtime_options[index]}
                                        setArrayState={setArrayState}
                                        setLeadTimes={setLeadTimes}
                                    />
                                ))}
                            </Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                    alignItems: 'center',
                                    alignContent: 'stretch',
                                }}
                            >
                                {SampleData.s7002.map((_, index) => (
                                    <ShelfSelect
                                        key={index}
                                        index={index}
                                        label={index === 0}
                                        shelfLifes={shelfLifes}
                                        options={data_shelflife_options[index]}
                                        setArrayState={setArrayState}
                                        setShelfLifes={setShelfLifes}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-around',
                            alignItems: 'center',
                            zIndex: 2,
                        }}
                    >
                        <Typography>Prioritization</Typography>
                        <Box
                            height="stretch"
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                gap: 5,
                            }}
                        >
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'space-around',
                                }}
                            >
                                {SampleData.s7002.map((_, index) => (
                                    <IngredientSlider
                                        key={index}
                                        index={index}
                                        sliders={sliders}
                                        setArrayState={setArrayState}
                                        setSliders={setSliders}
                                    />
                                ))}
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        width="200px"
                        height="300px"
                    >
                        <Box
                            display="flex"
                            flexDirection="row"
                            width="200px"
                            height="300px"
                            alignItems="center"
                        >
                            <Box width="100px" height="300px">
                                <HeatMap
                                    data={data_heatmap(
                                        leadTimes,
                                        shelfLifes,
                                        sliders
                                    ).map((item) => {
                                        return {
                                            ...item,
                                            data: [item.data[0]],
                                        };
                                    })}
                                    format={'>-$0.0f'}
                                    min={0}
                                    max={300}
                                />
                            </Box>
                            <Box width="100px" height="300px">
                                <HeatMap
                                    data={data_heatmap(
                                        leadTimes,
                                        shelfLifes,
                                        sliders
                                    ).map((item) => {
                                        return {
                                            ...item,
                                            data: [item.data[1]],
                                        };
                                    })}
                                    format=">-0.0f"
                                    min={0}
                                    max={16}
                                />
                            </Box>
                        </Box>
                    </Box>
                    <Box
                        display="flex"
                        flexDirection="column"
                        width="600px"
                        height="260px"
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            width="600px"
                            height="280px"
                            alignItems="center"
                        >
                            <Typography marginRight="70px">Waste</Typography>
                            {data_waste && (
                                <BarChart
                                    data={data_waste(
                                        leadTimes,
                                        shelfLifes,
                                        sliders
                                    )}
                                    format=">-$0.0~f"
                                />
                            )}
                            {/*<Typography marginRight="70px">
                                Stock Out
                            </Typography>
                            {data_stockout && (
                                <BarChart
                                    data={data_stockout(
                                        leadTimes,
                                        shelfLifes,
                                        sliders
                                    )}
                                />
                                    )}*/}
                        </Box>
                    </Box>
                </Box>
                <Box
                    sx={{
                        margin: '10px',
                        marginBottom: '30px',
                        borderStyle: 'solid',
                        borderColor: 'black',
                        borderWidth: '2px',
                    }}
                >
                    <PrepList data={data_preplist(sliders, leadTimes)} />
                </Box>
            </Box>
        </Box>
    );
}
